// extracted by mini-css-extract-plugin
export var container = "_ja-0";